// import { Loader } from '@googlemaps/js-api-loader'
// import { v4 } from 'uuid'
import { getUserInfo, getCustomerInfo } from '@/request/user.js'

const lfSignKey = 'S07Eu4zFndWhyzmblfHotel'
// 默认币种
const webCurrency = 'USD'
// 默认语言
const webLanguage = 'English'
// 默认来源
const webSource = 'roompai'
// 搜索区域公共变量
const childOld = {1: '<1', 2: '1', 3: '2', 4: '3', 5: '4', 6: '5', 7: '6', 8: '7', 9: '8', 10: '9', 11: '10', 12: '11', 13: '12', 14: '13', 15: '14', 16: '15', 17: '16', 18: '17'}
// 酒店列表公共变量
const levelOptions = {1: '五星/豪华', 2: '四星/高档', 3: '三星/舒适', 4: '二星/经济'}
const levelOptionsRev = {'五星/豪华': '1', '四星/高档': '2', '三星/舒适': '3', '二星/经济': '4'}
const propertyLanguage = {1: 'propertyClass5', 2: 'propertyClass4', 3: 'propertyClass3', 4: 'propertyClass2'}
const levelOptionsEn = {1: 'Property class 5', 2: 'Property class 4', 3: 'Property class 3', 4: 'Property class 2'}
const levelOptionsRevEn = {'Property class 5': '1', 'Property class 4': '2', 'Property class 3': '3', 'Property class 2': '4'}
// google map
// const googleMapKey = 'AIzaSyBQjGw20d_CJtFxMbS3niZ0DyA9YGUoKmc'
// const googleMapLoader = new Loader({
//   apiKey: googleMapKey, // 填写google控制台中的apikey
//   version: 'weekly',
//   libraries: ['places', '']
// })

// 酒店搜索
const weekZh = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
const weekMobileZh = ['日', '一', '二', '三', '四', '五', '六']
const weekPcEn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const weekEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
const monthMobileEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

// mapBox key
const MapBoxKey = 'sk.eyJ1IjoibGV0c2ZseXRlY2giLCJhIjoiY2w2cHhzOTF2MDE1cDNkbGppdnRmaWlvMiJ9.mzxzFDTtywYDyNTM-jTX3Q'
const MapBoxPublicKey = 'pk.eyJ1IjoibGV0c2ZseXRlY2giLCJhIjoiY2w1NjdheHZmMWdhbTNpdGRvenJraXVtcyJ9.G0x_cj55mn5Vq6KkosFtQg'

// encode
const linkEncodeKey = 'K9DZhY_bGCowU~v4M/:glfOLceBr@zxVSjNWEu;.nI6yH8p7AJRsd5|qaTm$2iX0F13tkPQ!'
const linkEncodeVal = '3@G0~tcIZs5xBKN.2RibH;zVS!uW/F:okCUm_dL6PYy87fOXAn94p$wTrEDMj1hgeqQJ|alv'
// const linkEncodeKey = 'K9DZhYbGCowUv4MglfOLceBrzxVSjNWEunI6yH8p7AJRsd5qaTm2iX0F13tkPQ'
// const linkEncodeVal = '3G0tcIZs5xBKN2RibHzVSuWFokCUmdL6PYy87fOXAn94pwTrEDMj1hgeqQJalv'
var linkQuerys = ''
var linkParams = ''

export default {
  lfSignKey,
  childOld,
  levelOptions,
  levelOptionsRev,
  levelOptionsEn,
  levelOptionsRevEn,
  propertyLanguage,
  webCurrency,
  webLanguage,
  webSource,
  MapBoxKey,
  MapBoxPublicKey,
  weekZh,
  weekMobileZh,
  weekPcEn,
  weekEn,
  monthEn,
  monthMobileEn,
  linkEncodeKey,
  linkEncodeVal,
  linkQuerys,
  linkParams,
  encryptionData: function (data, s) {
    var ua = navigator.userAgent
    data['ua'] = ua
    let flag = ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      var isAndroid = ua.match(/(Android|android|Linux)/i)
      var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      data['flag'] = 'mobile'
      data['device'] = isAndroid ? 'Android' : isiOS ? 'IOS' : 'Unknown'
    } else {
      var device = 'Unknown'
      if (ua.match(/(win|Win)/i)) {
        device = 'Windows'
      } else if (ua.match(/(mac|Mac|MAC)/i)) {
        device = 'Mac OS'
      } else if (ua.match(/(pad|pod|iPod|iPad)/i)) {
        device = 'Pad'
      } else if (ua.match(/(CrOS)/i)) {
        device = 'Chrome OS'
      } else if (ua.match(/(Pixel 7)/i)) {
        device = 'Google Pixel 7'
      }
      data['device'] = device
      data['flag'] = 'website'
    }
    //
    data['equipmentCode'] = s.IdentificationCode('MD5')
    data['fp'] = s.fingerprintCode()
    var roompaiStorageToken = localStorage.getItem('roompaiStorageToken')
    if (roompaiStorageToken === null || roompaiStorageToken === undefined) {
      roompaiStorageToken = ''
    }
    data['roompaiStorageToken'] = roompaiStorageToken
    data['hostName'] = window.location.hostname
    var that = s

    // 判断 地址中是否包含source 获取source
    // let params = new URL(location.href).searchParams
    // let source = params.get('source')
    let params = this.linkQuerys
    let source = params['source']

    // 传递参数 中 是否 source ( 不包含 )
    if (data.hasOwnProperty('source') !== true) {
      // 地址 中是否 包含source
      if (source === null || source === undefined) {
        data['source'] = webSource
      } else {
        data['source'] = source
      }
    }

    // 数据排序
    let dataKeyArr = []
    for (var i in data) {
      dataKeyArr.push(i)
    }
    dataKeyArr.sort()

    // 组合对象
    let json = {}
    let impStr = ''
    for (var j in dataKeyArr) {
      json[dataKeyArr[j]] = data[dataKeyArr[j]]
      impStr += data[dataKeyArr[j]]
    }
    // console.log(json)
    // console.log(impStr)
    // 加密
    json['sign'] = that.$md5(impStr + lfSignKey)
    return json
  },
  languageSet: function (s) {
    var languageCom = localStorage.getItem('languageSet')
    if (languageCom === null) {
      let params = new URL(location.href).searchParams
      let urlLan = params.get('language')
      let source = params.get('source')
      if (urlLan === 'en' || urlLan === 'zh') {
        languageCom = urlLan
      } else if (location.host === 'www.roompai.com' && source === 'sec') {
        languageCom = 'zh'
      } else {
        // languageCom = webLanguage
        languageCom = 'en'
      }
    }
    return languageCom
  },
  currencySet: function (s) {
    let currencyCom = localStorage.getItem('currencySet')
    if (currencyCom === null || currencyCom === '' || currencyCom === undefined || currencyCom === 'undefined' || currencyCom === 'null') {
      let params = new URL(location.href).searchParams
      let urlCur = params.get('currency')
      let source = params.get('source')
      if (urlCur === 'CNY' || urlCur === 'USD') {
        currencyCom = urlCur
      } else if (location.host === 'www.roompai.com' && source === 'sec') {
        currencyCom = 'CNY'
      } else {
        currencyCom = webCurrency
      }
    }
    return currencyCom
  },
  siteSet: function () {
    let site = 'www'
    if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com') {
      site = 'us'
    }
    return site
  },
  sessionidGet: function (s) {
    // 生成统一的 sessionid
    var sessionid = sessionStorage.getItem('hotelQuotedPriceSesstionId')

    if (sessionid === null) {
      sessionid = ''
    } else {
      sessionid = sessionStorage.getItem('hotelQuotedPriceSesstionId')
    }
    return sessionid
  },
  addClass: function (s, name) {
    if (s === null) {
      return false
    }
    if (name) {
      s.className ? s.className = s.className + ' ' + name : s.className = name
    }
  },
  removeClass: function (s, name) {
    if (s === null) {
      return false
    }
    let classArr = s.className.split(' ')
    let index = classArr.indexOf(name)
    if (index > -1) {
      classArr.splice(index, 1)
    }
    s.className = classArr.join(' ')
  },
  tokenValid: function () {
    var token = localStorage.getItem('token')
    let locationHref = window.document.location.href
    if (token === undefined || token === null || token === 'null') {
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    } else {
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {'token': token, 'time': time}
      var data = this.common.encryptionData(dataJson, this)
      getUserInfo(data).then(res => {
        if (res.flag !== '200') {
          localStorage.removeItem('token')
          // localStorage.removeItem('getCookie')
          localStorage.removeItem('sessionid')
        }
      })
    }
  },
  isMobile: function () {
    var ismobile = false
    if (document.documentElement.clientWidth < 992) {
      ismobile = true
    }
    return ismobile
  },
  isWechat: function () {
    return navigator.userAgent.indexOf('MicroMessenger') !== -1
  },
  getWechatTransferPage: function (appid) {
    return encodeURIComponent('https://www.roompai.com/login/wechatLogin?domain=' + window.location.hostname + '&appid=' + appid + '&pagePath=' + window.location.pathname)
  },
  getWechatMobileAuthorizationUrl: function () {
    return 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9e6cb7f7e34e656a&redirect_uri=' + this.getWechatTransferPage('wx9e6cb7f7e34e656a') + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
  },
  getWechatPcAuthorizationUrl: function (lang) {
    return 'https://open.weixin.qq.com/connect/qrconnect?appid=wx4a536782ca2e3f8c&scope=snsapi_login&redirect_uri=' + encodeURIComponent('https://www.roompai.com/login/wechatLogin?domain=' + window.location.hostname + '&appid=wx4a536782ca2e3f8c') + '&lang=' + lang + '#wechat_redirect'
  },
  getGoogleAuthorizationUrl: function () {
    return 'https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/userinfo.profile%20https://www.googleapis.com/auth/userinfo.email&include_granted_scopes=true&response_type=token&state=3EAB37D9D5310B&redirect_uri=' + encodeURIComponent('https://us.roompai.com/login/OAuth2?operation=GoogleAuth&domain=' + window.location.hostname) + '&client_id=639588403126-iao8aif7s0j6jheb2b048d2aqkbu5j26.apps.googleusercontent.com'
  },
  getFacebookAuthorizationUrl: function () {
    return 'https://www.facebook.com/v18.0/dialog/oauth?response_type=token&client_id=680011454058903&scope=email%2Cpublic_profile&redirect_uri=' + encodeURIComponent('https://us.roompai.com/login/OAuth2?operation=FacebookAuth&domain=' + window.location.hostname)
  },
  getAppleAuthorizationUrl () {
    return 'https://appleid.apple.com/auth/authorize?response_type=code&client_id=com.roompai.us&redirect_uri=' + encodeURIComponent('https://us.roompai.com/api/authorizedLoginUs?domain=' + window.location.hostname + '&operation=AppleAuth') + '&state=roompai20241021&scope=name%20email&response_mode=form_post'
  },
  defaultCheckDate: function () {
    var checkDate = []
    let d = new Date()
    var year = d.getFullYear()
    var month = d.getMonth()
    var tian = d.getDate()
    var dayNum = new Date(year, parseInt(month) + 1, 0).getDate()
    if (tian >= dayNum) {
      tian = 0
      month += 1
    }
    if (month > 12) {
      month = 12
      year += 1
    }
    var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
    checkDate.push(year + '-' + monthSelect + '-' + (parseInt(tian) + 1))
    checkDate.push(year + '-' + monthSelect + '-' + (parseInt(tian) + 2))

    return checkDate
  },
  // getFacilityInfo: function () {
  //   console.log('aaa', navigator)
  // },
  getUserIP: function () {
    var time = parseInt(new Date().getTime() / 1000)
    var data = {'time': time}
    getCustomerInfo(data).then(res => {
      // console.log(res)
    })
  },
  // 识别码信息 开始
  canvasFingerprint: function () {
    // 创建一个隐藏的 Canvas 元素
    var canvas = document.createElement('canvas')
    canvas.width = 200
    canvas.height = 200
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    // 获取 2D 上下文
    var context = canvas.getContext('2d')
    // 在 Canvas 上绘制一些内容
    context.textBaseline = 'alphabetic'
    context.fillStyle = '#f60'
    context.fillRect(125, 1, 62, 20)
    context.fillStyle = '#069'
    context.font = '11pt no-real-font-123'
    context.fillText('Cwm fjordbank glyphs vext quiz', 2, 15)
    context.fillStyle = 'rgba(102, 204, 0, 0.2)'
    context.font = '18pt Arial'
    context.fillText('Cwm fjordbank glyphs vext quiz', 4, 45)
    // 获取 Canvas 数据
    var imageData = context.getImageData(0, 0, canvas.width, canvas.height)
    // 移除 Canvas 元素
    document.body.removeChild(canvas)

    var data = imageData.data
    // 计算指纹
    var hash = 0
    for (var i = 0; i < data.length; i += 4) {
      hash += data[i] + data[i + 1] + data[i + 2]
    }
    hash = hash.toString(16)

    return hash
  },
  getPluginsInfo: function (plugins) {
    const pluginInfo = []
    for (let i = 0; i < plugins.length; i++) {
      const plugin = plugins[i]
      // pluginInfo.push({
      //   name: plugin.name,
      //   filename: plugin.filename,
      //   description: plugin.description
      // })
      pluginInfo.push(plugin.name)
    }
    return pluginInfo.join(' | ')
  },
  getMimeTypesInfo: function (mimeTypes) {
    const mimeTypeInfo = []
    for (let i = 0; i < mimeTypes.length; i++) {
      const mimeType = mimeTypes[i]
      mimeTypeInfo.push({
        type: mimeType.type,
        description: mimeType.description,
        suffixes: mimeType.suffixes
      })
    }
    return mimeTypeInfo
  },
  getConnectionInfo: function (connection) {
    if (connection) {
      // return {
      //   type: connection.type,
      //   effectiveType: connection.effectiveType,
      //   downlink: connection.downlink,
      //   rtt: connection.rtt,
      //   saveData: connection.saveData
      // }
      return connection.effectiveType
    }
    return null
  },
  getClipboardInfo: function (clipboard) {
    if (clipboard) {
      return {
        read: typeof clipboard.read === 'function',
        write: typeof clipboard.write === 'function'
      }
    }
    return null
  },
  concatenateValues: function (obj) {
    let result = ''
    for (const key in obj) {
      result += obj[key] + ' !|! '
    }
    return result
  },
  hotelid_decrypt: function (hotelid) {
    return parseInt(hotelid) - 7
  },
  generateWebGLFingerprint: function () {
    try {
      // 创建一个 WebGL 上下文
      var canvas = document.createElement('canvas')
      var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')

      if (!gl) {
        return 'WebGL not supported, unable to generate fingerprint.'
      }

      // 查询 WebGL 上下文的参数
      // const fingerprintData = {
      //   version: gl.getParameter(gl.VERSION),
      //   renderer: gl.getParameter(gl.RENDERER),
      //   vendor: gl.getParameter(gl.VENDOR),
      //   extensions: gl.getSupportedExtensions()
      // }
      // 生成指纹
      // const fingerprint = JSON.stringify(fingerprintData)
      var fingerprint = gl.getSupportedExtensions().join(' | ')
      gl = null
      return fingerprint
    } catch (error) {
      console.error('Error generating WebGL fingerprint:', error)
      return 'Error generating WebGL fingerprint.'
    }
  },
  webFont: function () {
    // 创建一个临时的 <span> 元素，用于测试字体
    const testElement = document.createElement('span')
    testElement.style.fontFamily = 'initial' // 设置为默认字体
    testElement.style.display = 'none'
    document.body.appendChild(testElement)
    const computedStyle = window.getComputedStyle(testElement)
    const defaultFont = computedStyle.fontFamily
    document.body.removeChild(testElement)

    // 打印系统字体列表
    return defaultFont
  },
  // 识别码信息 结束
  // 停止滚动
  stopScroll: function () {
    var mo = function (e) {
      e.preventDefault()
    }
    document.body.style.overflow = 'hidden'
    document.addEventListener('touchmove', mo, false)
  },
  // 允许滚动
  canScroll: function () {
    var mo = function (e) {
      e.preventDefault()
    }
    document.body.style.overflow = ''
    document.addEventListener('touchmove', mo, false)
  },
  webLinkQuerys: function (params) {
    // 保留链接

    // 链接参数转换
    this.linkQuerys = this.linkDecode(params.querys, 'obj')

    // linkParams
    this.linkParams = params
    delete this.linkParams.querys
  },
  routePath: function (path) {
    var staticPath = path.split('/').slice(0, -1).join('/')
    if (path !== '/' && path.endsWith('/')) {
      staticPath += '/'
    }

    return staticPath
  },
  // 对象 转 链接
  objectToLink: function (obj) {
    // var searchParams = Object.entries(obj).map(([key, value]) => `${key}=${value}`).join('&')
    var queryStringParts = []

    // 处理非数组值
    Object.keys(obj).forEach(key => {
      if (!Array.isArray(obj[key])) {
        queryStringParts.push(`${key}=${obj[key]}`)
      }
    })

    if (obj.childNums && Array.isArray(obj.childNums)) {
      obj.childNums.forEach(item => {
        queryStringParts.push(`childNums[]=${item}`)
      })
    }
    var queryString = queryStringParts.join('&')

    return queryString
  },
  // 对象 转 链接
  linkToobject: function (link) {
    // 特殊字符替换
    var linkAscii = link.replace(' & ', '∈')
    var params = new URLSearchParams(linkAscii)
    var obj = {}
    var childNums = []
    for (const [key, value] of params) {
      let keyNew = key.replace('∈', ' & ')
      let valueNew = value.replace('∈', ' & ')

      if (keyNew !== 'childNums[]') {
        obj[keyNew] = valueNew
      } else {
        childNums.push(valueNew)
      }
    }
    if (childNums.length > 0) {
      obj['childNums'] = childNums
    }
    return obj
  },
  // 连接 拼接 数据
  linkCombine: function (cropping = 0) {
    let linkEncodeKeyLs = linkEncodeKey.split('')
    let linkEncodeValLs = linkEncodeVal.split('')

    // 求余数
    let croppingRemain = cropping % linkEncodeKeyLs.length

    // 拼接
    let firstLinkKey = linkEncodeKeyLs.slice(0, croppingRemain)
    let remainingLinkKey = linkEncodeKeyLs.slice(croppingRemain)
    let linkCroppingKey = [...remainingLinkKey, ...firstLinkKey]

    let result = {}
    for (let i = 0; i < linkCroppingKey.length; i++) {
      result[linkCroppingKey[i]] = linkEncodeValLs[i]
    }

    return result
  },
  // 连接 加密
  linkEncode: function (link, paramType = 'str', cropping = 0, prefix = '++', split = '--') {
    // 如果为空
    if (link === undefined) {
      return ''
    }

    // 申城拼接数组
    let combine = this.linkCombine(cropping)
    var linkNew = link
    if (paramType !== 'str') {
      linkNew = this.objectToLink(link)
    }

    // 参数特殊字符替换
    let linkReplace = linkNew.replace(prefix, '∑')
    linkReplace = linkReplace.replace(split, '∏')

    // console.log(linkReplace)
    // 先将'&'替换为'+' 再将'='也替换为'#'
    let linkEncode = linkReplace.replace(/&/g, prefix)
    linkEncode = linkEncode.replace(/=/g, split)

    let linkFlip = Array.from(linkEncode).filter(char => char !== '')

    let ascii = ''
    for (let j = 0; j < linkFlip.length; j++) {
      if (!combine.hasOwnProperty(linkFlip[j])) {
        ascii += linkFlip[j]
      } else {
        ascii += combine[linkFlip[j]]
      }
    }
    return encodeURI(ascii)
  },
  // 连接 解密
  linkDecode: function (link, callback = 'str', cropping = 0, prefix = '\\+\\+', split = '--') {
    // 如果为空
    if (link === undefined) {
      if (callback !== 'str') {
        return {}
      }
      return ''
    }
    // 拼接数组
    let combine = this.linkCombine(cropping)

    // 特殊字符替换
    let linkReplace = link.replace(' & ', '∈')
    linkReplace = linkReplace.replace('%20++%20', '∈')

    // 先将'&'替换为'+' 再将'='也替换为'#'
    let linkEncode = linkReplace.replace(new RegExp(prefix, 'g'), '&')
    linkEncode = linkEncode.replace(new RegExp(split, 'g'), '=')

    // 使用split方法模拟explode函数
    let linkEncodeArr = linkEncode.split('&')
    let linkEncodeArrNew = []

    // 遍历数组，使用decodeURIComponent解码每个值
    linkEncodeArr.forEach((val, key) => {
      let [keyPart, valuePart] = val.split('=') // 分割键和值

      // 因为要做页面搜索 不修改酒店 不跳转页面（所以需要解析地址栏中的酒店名称）
      let decodedKey = decodeURI(keyPart)
      let decodedValue = decodeURI(valuePart)

      // let decodedValue = valuePart // 解码值
      linkEncodeArrNew.push(`${decodedKey}=${decodedValue}`) // 将键和已解码的值重新组合并推入新数组
    })
    // 使用join方法模拟implode函数
    let linkEncodeEscape = linkEncodeArrNew.join('&')

    // 翻转数组
    let allFlip = {}
    for (let key in combine) {
      // 注意：如果原数组中有重复的值，这里只会保留最后一个键-值对
      allFlip[combine[key]] = key
    }

    let linkFlip = Array.from(linkEncodeEscape).filter(char => char !== '')
    let ascii = ''
    for (let j = 0; j < linkFlip.length; j++) {
      if (!allFlip.hasOwnProperty(linkFlip[j])) {
        ascii += linkFlip[j]
      } else {
        ascii += allFlip[linkFlip[j]]
      }
    }

    // 特殊字符替换
    ascii = ascii.replace('∈', ' & ')

    // 替换链接中的特殊字符
    var asciiDecode = ascii.replace('∑', '++').replace('%E2%88%91', '++')
    asciiDecode = asciiDecode.replace('∏', '--').replace('%E2%88%8F', '--')

    if (callback !== 'str') {
      return this.linkToobject(asciiDecode)
    }
    return asciiDecode
  }
}



// WEBPACK FOOTER //
// ./src/util/common.js